/**
 * SEO Utilities for JSON-LD Schema Markup
 * Generates structured data for Google Search, Rich Snippets, etc.
 */

export const generateOrganizationSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'EducationalOrganization',
  name: 'Algodoor - Programming & Cloud Training Institute',
  description:
    'Leading tech training institute in Bhopal offering JavaScript, React, Node.js, AWS, Frontend Development, and GitHub Copilot courses with 100% placement support.',
  url: 'https://www.algodoor.com',
  logo: 'https://images.unsplash.com/photo-1627398242454-45a1465c2479?w=256&auto=format&fit=crop&q=80',
  sameAs: [
    'https://www.facebook.com/algodoor',
    'https://www.linkedin.com/company/algodoor',
    'https://www.instagram.com/algodoor',
    'https://www.youtube.com/@algodoor',
  ],
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'Customer Service',
    telephone: '+91-7489017551',
    email: 'info@algodoor.com',
    areaServed: 'Bhopal, Madhya Pradesh',
  },
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Bangalore, Karnataka',
    addressLocality: 'Bangalore',
    addressRegion: 'Karnataka',
    postalCode: '560001',
    addressCountry: 'IN',
  },
});

export const generateCourseSchema = (course) => ({
  '@context': 'https://schema.org',
  '@type': 'Course',
  name: course.title,
  description: course.description,
  image: course.image,
  duration: `PT${course.duration}`,
  priceCurrency: 'INR',
  price: course.price.replace(/[₹,]/g, ''),
  provider: {
    '@type': 'EducationalOrganization',
    name: 'Algodoor',
  },
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: '4.8',
    ratingCount: '450',
  },
  teaches: course.syllabus
    ?.slice(0, 5)
    ?.map((module) => module.module)
    ?.join(', '),
});

export const generateBreadcrumbSchema = (breadcrumbs) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: breadcrumbs.map((item, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: item.name,
    item: `https://www.algodoor.com${item.url}`,
  })),
});

export const generateLocalBusinessSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  '@id': 'https://www.algodoor.com',
  name: 'Algodoor - Tech Training Institute Bhopal',
  image: 'https://images.unsplash.com/photo-1627398242454-45a1465c2479?w=500&auto=format&fit=crop&q=80',
  description:
    'Professional tech training institute providing JavaScript, React, Node.js, AWS, and full-stack development courses in Bhopal.',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Bangalore, Karnataka',
    addressLocality: 'Bangalore',
    addressRegion: 'Karnataka',
    postalCode: '560001',
    addressCountry: 'IN',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: '23.1815',
    longitude: '79.9864',
  },
  telephone: '+91-7489017551',
  url: 'https://www.algodoor.com',
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      opens: '10:00',
      closes: '18:00',
    },
  ],
  priceRange: '₹12,000 - ₹20,000',
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: '4.8',
    ratingCount: '450',
    bestRating: '5',
    worstRating: '1',
  },
});

export const generateFAQSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'What courses does Algodoor offer?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Algodoor offers JavaScript Fullstack Development, AWS Cloud with DevOps, Frontend Mastery, and GitHub Copilot training courses with 100% placement support.',
      },
    },
    {
      '@type': 'Question',
      name: 'Where is Algodoor located?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Algodoor is based in Bangalore, Karnataka with training centers serving students across Bhopal and other cities via online programs.',
      },
    },
    {
      '@type': 'Question',
      name: 'Do you provide placement assistance?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yes, all our courses include 100% placement support, mock interviews, resume building, and expert mentorship from top IT companies.',
      },
    },
    {
      '@type': 'Question',
      name: 'What is the course duration?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Our courses range from 1 month to 3 months depending on the specialization. Check individual course details for more information.',
      },
    },
    {
      '@type': 'Question',
      name: 'Can I enroll online?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yes, all our courses are available online and offline. You can enroll from anywhere and attend classes at your convenience.',
      },
    },
  ],
});
